module.exports = __webpack_public_path__ + "img/rewards25.95f7785.svg";